var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "print" } }, [
    _c(
      "div",
      { staticClass: "book m-auto" },
      _vm._l(
        Math.ceil(_vm.goodstransfer.orders.length / _vm.maxOrderLists),
        function(data, idx) {
          return _c("div", { key: idx, staticClass: "page" }, [
            _c("div", { staticClass: "subpage" }, [
              _c(
                "div",
                {
                  staticClass: "top-header",
                  staticStyle: { padding: "0 0 30px 0" }
                },
                [
                  idx == 0
                    ? _c("div", { staticClass: "company-info" }, [
                        _vm.shopInfo.logo.thumbnail
                          ? _c("img", {
                              attrs: { src: _vm.shopInfo.logo.thumbnail }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "name" }, [
                          _c("strong", { staticClass: "text-black" }, [
                            _vm._v(_vm._s(_vm.shopInfo.shop_name))
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(_vm._s(_vm.shopInfo.info.location.address))
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "document-type" }, [
                    _c("h2", { staticClass: "text-black" }, [
                      _vm._v(_vm._s(_vm.$t("documents.gt")))
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.goodstransfer.gt_code))])
                  ])
                ]
              ),
              _vm._v(" "),
              idx == 0
                ? _c("div", { staticClass: "content" }, [
                    _c("div", { staticClass: "left" }, [
                      _c("div", { staticClass: "section" }, [
                        _c("p", { staticClass: "label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("apps.inventory.message.transferdate")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "detail" }, [
                          _vm._v(
                            _vm._s(
                              _vm.getDateTime(_vm.goodstransfer.scheduled_at)
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "section" }, [
                        _c("p", { staticClass: "label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "apps.inventory.message.postingattransferredorders"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "detail" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.goodstransfer.posting_at
                                  ? _vm.getDateTime(
                                      _vm.goodstransfer.posting_at
                                    )
                                  : "-"
                              ) +
                              "\n              "
                          )
                        ])
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "order" }, [
                _c("table", [
                  _c("thead", [
                    _c("tr", [
                      _vm._m(0, true),
                      _vm._v(" "),
                      _c("td", { attrs: { width: "40%" } }, [
                        _c("b", [_vm._v(_vm._s(_vm.$t("message.description")))])
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _c("b", [_vm._v(_vm._s(_vm.$t("message.quantity")))])
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _c("b", [_vm._v(_vm._s(_vm.$t("status.gt.done")))])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.groupOrders[idx].orders, function(ref, idx_) {
                      var item = ref.item
                      var quantity = ref.quantity
                      var done = ref.done
                      return _c("tr", { key: idx_ }, [
                        _c("td", { attrs: { width: "10px" } }, [
                          _c("b", [
                            _vm._v(_vm._s(_vm.maxOrderLists * idx + (idx_ + 1)))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { width: "40%" } }, [
                          _vm._v(_vm._s(item))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _vm._v(_vm._s(_vm.getNumber(quantity)))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _vm._v(_vm._s(_vm.getNumber(done)))
                        ])
                      ])
                    }),
                    0
                  )
                ])
              ]),
              _vm._v(" "),
              Math.ceil(_vm.goodstransfer.orders.length / _vm.maxOrderLists) >
                0 &&
              idx !==
                Math.ceil(_vm.goodstransfer.orders.length / _vm.maxOrderLists) -
                  1
                ? _c("div", { staticClass: "next-page" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("message.havenextpage")) +
                        "\n        "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              idx >=
              Math.ceil(_vm.goodstransfer.orders.length / _vm.maxOrderLists) - 1
                ? _c(
                    "div",
                    {
                      staticClass: "footer",
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "note",
                          staticStyle: { width: "auto", "max-width": "360px" }
                        },
                        [
                          _vm.goodstransfer.note
                            ? _c("div", { staticClass: "section" }, [
                                _c("p", [
                                  _vm._v(_vm._s(_vm.$t("message.note")))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticStyle: { "white-space": "pre-wrap" }
                                  },
                                  [_vm._v(_vm._s(_vm.goodstransfer.note))]
                                )
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "total",
                          staticStyle: {
                            width: "auto",
                            margin: "0",
                            flex: "1",
                            "max-width": "400px"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "section",
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "column"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "section",
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between",
                                    margin: "0 0 10px 0"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        width: "auto",
                                        "max-width": "none",
                                        flex: "none"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "apps.inventory.message.pickfrom"
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        width: "auto",
                                        "max-width": "none",
                                        flex: "1",
                                        "text-align": "right"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "text-underline-border"
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.getWhLocationName(
                                                  _vm.goodstransfer.stockout
                                                    .warehouse_id,
                                                  _vm.goodstransfer.stockout
                                                    .bin_location_id
                                                )
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "section",
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between",
                                    margin: "0 0 10px 0"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        width: "auto",
                                        "max-width": "none",
                                        flex: "none"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "apps.inventory.message.shipto"
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        width: "auto",
                                        "max-width": "none",
                                        flex: "1",
                                        "text-align": "right"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "text-underline-border"
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.getWhLocationName(
                                                  _vm.goodstransfer.stockin
                                                    .warehouse_id,
                                                  _vm.goodstransfer.stockin
                                                    .bin_location_id
                                                )
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e()
            ])
          ])
        }
      ),
      0
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { width: "10px" } }, [_c("b", [_vm._v("#")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-797e52a5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-797e52a5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/inventory/goodstransfer/include/PrintGt.vue
// module id = null
// module chunks = 